import { Menu } from "@arco-design/web-react";
// import { IconApps } from "@arco-design/web-react/icon";
// import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useNavData } from "src/layouts/dashboard/config-navigation";
// routes
import { usePathname, useRouter } from "src/routes/hook";
import { useActiveLink } from "src/routes/hook/use-active-link";
//

// ----------------------------------------------------------------------

export default function NavList() {
    const pathname = usePathname();
    const navData = useNavData();
    const data = navData?.[0]?.items
    const router = useRouter();

    // data here can be an array of items or a single item when used recursively
    const items = Array.isArray(data) ? data : [data].filter(Boolean);

    const active = useActiveLink(items[0]?.path, true);

    const [open, setOpen] = useState(active);
    const handleClick = (path) => {
        // navigate to the path
        router.push(path);
    }

    // 使用 state 管理 openKeys 和 selectedKeys
    const [openKeys, setOpenKeys] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);

    // 当路径变化时更新菜单状态
    useEffect(() => {
        const newOpenKeys = [];
        const newSelectedKeys = [];

        items.forEach((item, index) => {
            if (item.children?.length > 0) {
                // 检查子菜单项是否匹配当前路径
                item.children.forEach((child, childIndex) => {
                    if (pathname === child.path || pathname.startsWith(child.path)) {
                        newOpenKeys.push(String(index));
                        newSelectedKeys.push(`${index}_${childIndex}`);
                    }
                });
            } else if (pathname === item.path || pathname.startsWith(item.path)) {
                // 检查单个菜单项是否匹配当前路径
                newSelectedKeys.push(String(index));
            }
        });

        setOpenKeys(newOpenKeys);
        setSelectedKeys(newSelectedKeys);
    }, [pathname, items]);

    useEffect(() => {
        if (!active) {
            setOpen(false);
        }
    }, [pathname, active]);

    return (
        <Menu 
            style={{ width: '100%' }} 
            openKeys={openKeys} 
            selectedKeys={selectedKeys}
            onClickMenuItem={(key) => {
                // 处理单个菜单项点击
                const index = parseInt(key, 10);
                if (Number.isNaN(index) === false && items[index] && !items[index].children) {
                    handleClick(items[index].path);
                }
            }}
            onClickSubMenu={(key, keys) => {
                setOpenKeys(keys);
            }}
        >
            {items.map((item, index) => {
                if (item.children?.length > 1) {
                    return (
                        <Menu.SubMenu
                            key={index}
                            title={
                                <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                                    {item.icon}

                                    {item.title}
                                </div>
                            }
                        >
                            {item.children.map((child, idx) => (
                                <Menu.Item style={{ marginLeft: 16 }} key={`${index}_${idx}`} onClick={() => handleClick(child.path)}>
                                    {child.title}
                                </Menu.Item>
                            ))}
                        </Menu.SubMenu>
                    );
                }

                return (
                    <Menu.Item key={index} onClick={() => handleClick(item.path)}>
                        <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            {item.icon}

                            {item.title}
                        </div>
                    </Menu.Item>
                );

            })}
        </Menu>
    );
}

NavList.propTypes = {
    // config: PropTypes.object,
    // depth: PropTypes.number,
};

// ----------------------------------------------------------------------

